var _style, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{display:none;}\n\t.st2{display:inline;fill:#FFFFFF;}\n\t.st3{display:inline;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1_00000132086336581971264980000012016021049625426561_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M844.5,172.7c0,22-17.5,39.9-39.1,39.9H665.2c-26.2,0-47.5-21.7-47.5-48.5s21.3-48.5,47.5-48.5 c0.4,0,0.8,0,1.2,0c9.5-26.2,34.2-44.8,63.2-44.8c35.2,0,64.2,27.6,67.2,62.8c2.8-0.6,5.6-1,8.6-1 C826.9,132.7,844.5,150.6,844.5,172.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1_00000042007405082281933360000005657197519820471707_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.2,172.7c0,22-17.5,39.9-39.1,39.9H371c-26.2,0-47.5-21.7-47.5-48.5s21.3-48.5,47.5-48.5 c0.4,0,0.8,0,1.2,0c9.5-26.2,34.2-44.8,63.2-44.8c35.2,0,64.2,27.6,67.1,62.8c2.8-0.6,5.6-1,8.6-1 C532.7,132.7,550.2,150.6,550.2,172.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2_00000106132340310626874770000010227425614068004524_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.7,28.4c-40.5,0-73.3,32.8-73.3,73.3s73.3,153.5,73.3,153.5s73.3-113,73.3-153.5 C215,61.2,182.2,28.4,141.7,28.4z M141.7,126c-16.6,0-30-13.4-30-30c0-16.6,13.4-30,30-30s30,13.4,30,30S158.3,126,141.7,126z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_3",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 141.7,
    cy: 89.9,
    r: 61.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.9,255.1c0-48.7,45.6-88.1,101.8-88.1s101.8,39.5,101.8,88.1H39.9z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.5,140.2H115c-2.1,9-4.5,18.2-7,26.8l-2.4,9H125l-2.4-9C120,158.5,117.8,149.1,115.5,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.8,148.9c-3,0-5.8,0.3-8.6,1c-3-35.2-31.9-62.8-67.1-62.8c-29,0-53.7,18.6-63.2,44.8c-0.4,0-0.8,0-1.2,0 c-26.2,0-47.5,21.7-47.5,48.5c0,26.8,21.3,48.5,47.5,48.5h140.1c21.6,0,39.1-17.9,39.1-39.9C249.9,166.8,232.4,148.9,210.8,148.9z  M134.3,209.7l-5.7-21H102l-5.7,21H79.7l26.2-81.9h19.2l26.3,81.9H134.3z M177.4,209.7h-16.4v-81.9h16.4V209.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/구름test.786cd90504dfe3ae78e314386619b335.svg";
export { ForwardRef as ReactComponent };